import BaseComponent from './BaseComponent';
import gsap from 'gsap';

export default class SearchPopup extends BaseComponent {
	constructor(element) {
		super();

		// State
		this.isVisible = false;

		// Elements
		this.el = element;

		this.openPopupButton = this.el.querySelector('[data-search-popup-button]');
		this.popUp = this.el.querySelector('[data-search-popup]');

		gsap.set(this.popUp, {
			autoAlpha: 0,
		});

		// Event listeners
		this.openPopupButton.addEventListener('click', () => this.toggle());

		this.addListener(document, 'click', (e) => {
			if (!this.el.contains(e.target)) {
				this.hide();
			}
		});

		this.addListener(document, 'keydown', (e) => {
			if (e.key === 'Escape') {
				this.hide();
			}
		});
	}

	toggle() {
		if (this.isVisible) {
			this.hide();
		} else {
			this.show();
		}
	}

	show() {
		if (this.isVisible) {
			return;
		}
		this.isVisible = true;

		gsap.to(this.popUp, {
			autoAlpha: 1,
			duration: 0.3,
			ease: 'none',
		});
	}

	hide() {
		if (!this.isVisible) {
			return;
		}
		this.isVisible = false;

		gsap.to(this.popUp, {
			autoAlpha: 0,
			duration: 0.2,
			ease: 'none',
		});
	}

	destroy() {
		super.destroy();
		this.removeAllListeners();
	}
}
